import {Pipe, PipeTransform} from "@angular/core";
import moment from 'moment';

@Pipe({ name: 'MomentDate' })
export class MomentDatePipe implements PipeTransform {
  transform(date: any, format: any, noUTC = false) {
    return noUTC ? moment.utc(date).format(format) : moment.utc(date).local().format(format);
  }
}
